import { useLoading as useLoadingHook } from '@aka/vue-kit';

export const useLoading = (
    options?: Parameters<typeof useLoadingHook>[0] & {
        toast?: { pending?: string; error?: string; success?: string } | string;
    },
) => {
    const { isSelfLoading, isLoading, isParentLoading, withLoading: hookWithLoading } = useLoadingHook(options);

    const withLoading = <T extends Array<unknown>, U>(fn: (...args: T) => Promise<U> | U) => {
        const wrappedMethod = hookWithLoading(fn);

        return (...args: T) => {
            const wasAnyLoading = isLoading.value;
            const promise = wrappedMethod(...args);
            if (options?.toast != null && !wasAnyLoading) {
                if (typeof options.toast === 'string') {
                    toast.promise(promise, {
                        error: `${options.toast} failed`,
                        success: `${options.toast} succeeded`,
                        pending: `${options.toast} in progress`,
                    });
                } else {
                    toast.promise(promise, options.toast);
                }
            }
            return promise;
        };
    };

    return {
        isSelfLoading,
        isLoading,
        isParentLoading,
        withLoading,
    };
};
